/**
 * Enum for support request status.
 */
export enum SupportRequestStatus {
  /**
   * New or open support request.
   */
  New = 0,
  /**
   * Support request in progress.
   */
  InProgress = 1,
  /**
   * Support request closed.
   */
  Closed = 2,
}
